/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConnectedAccount } from '../models/ConnectedAccount';
import type { ConnectToken } from '../models/ConnectToken';
import type { IntegrationApp } from '../models/IntegrationApp';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IntegrationsService {
    /**
     * List Apps
     * The apps an account can connect, grouped by category.
     * @returns IntegrationApp Successful Response
     * @throws ApiError
     */
    public static listApps(): CancelablePromise<Array<IntegrationApp>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/apps',
        });
    }
    /**
     * Create Connect Token
     * A short-lived token the frontend SDK spends to open Pipedream's connect flow.
     * @returns ConnectToken Successful Response
     * @throws ApiError
     */
    public static createConnectToken(): CancelablePromise<ConnectToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/connect-token',
        });
    }
    /**
     * List Connected Accounts
     * Every third-party account this account has connected, across its brands.
     * @returns ConnectedAccount Successful Response
     * @throws ApiError
     */
    public static listConnectedAccounts(): CancelablePromise<Array<ConnectedAccount>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/accounts',
        });
    }
    /**
     * Disconnect Account
     * Revoke one connection. Only connections made by this account can be removed.
     * @param connectedId
     * @returns void
     * @throws ApiError
     */
    public static disconnectAccount(
        connectedId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/integrations/accounts/{connected_id}',
            path: {
                'connected_id': connectedId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
